import "react-datepicker/dist/react-datepicker.css";
import CustomDateInputProps from "../../services/models/customDateInputProps.model";
import utils from "../../services/utils";
import CustomDatePicker from "./CustomDatePicker";
import { useLocation } from "react-router-dom";

function CustomDateInput({
  disabledWhen,
  values,
  parentContainerClass,
  containerClass,
  roundedInput,
  labelInfo,
  setFieldValue,
  displayWhen,
  handleDate,
  testOrderTable,
  ...props
}: CustomDateInputProps): JSX.Element | null {
  const { getFieldMeta } = props;
  const fieldName: any = props?.name && props?.name;
  const errorString = getFieldMeta?.(fieldName).error ?? "";
  const fieldTouched = getFieldMeta?.(fieldName).touched ?? "";
  const location = useLocation()
  const generateLabelpopup = location?.pathname === '/access/shipments/unshipped-orders'
  const disabled = !!disabledWhen
    ? utils.displayHandler(disabledWhen, values)
    : props.disabled;
  const showError = errorString && fieldTouched;
  const value: any = getFieldMeta?.(fieldName)?.value ?? props?.value ?? "";
  if (!!displayWhen) {
    if (!utils.displayHandler(displayWhen, values ?? {})) {
      return null;
    }
  }

  return (
    <div
      className={`my-3 w-full ${parentContainerClass} ${disabled && "cursor-not-allowed"
        }`}
    >
      <div
        className={`${roundedInput ? "" : testOrderTable ? "globalFilterDateInput" : "normalTextInputContainer"
          } ${containerClass} ${generateLabelpopup && 'mt-2.5'} flex flex-col  ${showError ? "border-requiredRed" : ""
          } `}
      >
        {labelInfo && (
          <label
            htmlFor={labelInfo.inputId}
            className={`inputLabel ${labelInfo.required ? "after:content-['*'] after:ml-1 after:text-requiredRed"
                : ""
              } ${showError ? "text-requiredRed" : ""} ${roundedInput ? "font-semibold" : ""
              }`}
          >
            {labelInfo.label}
          </label>
        )}
        <CustomDatePicker
          value={value}
          fieldName={fieldName}
          setFieldValue={setFieldValue}
          showError={showError}
          disabled={disabled}
          handleDate={handleDate}
          testOrderTable={testOrderTable}
          UMSeqDateOfCollection={fieldName === 'laboratoryInfo.dateOfCollection' && (values.testTypeId === 4 || values.testTypeId === 7)}
          {...props}
        />
      </div>
      {showError && (
        <h6 className="text-xs text-requiredRed mt-1">{errorString}</h6>
      )}
    </div>
  );
}

export default CustomDateInput;
